/* 专有名词翻译 */
export default {
  zh: {
    lead: '潜在客户',
    leads: '潜在客户',
    account: '客户',
    accounts: '客户',
    opport: '机会',
    opportunities: '机会',
    users: '用户',
    joinDate: '入职日期',
    department: '部门',
    leadPageLayout: '潜在客户页面结构',
    accountPageLayout: '客户页面结构',
    opportunitiesPageLayout: '机会页面结构',
    field: '字段',
    fields: '字段',
    dashboard: '总览',
    report: '报告',
    reports: '报告',
    view: '视图',
    months: {
      Jan: '一月',
      Feb: '二月',
      Mar: '三月',
      Apr: '四月',
      May: '五月',
      Jun: '六月',
      Jul: '七月',
      Agu: '八月',
      Sep: '九月',
      Oct: '十月',
      Nov: '十一月',
      Dec: '十二月',
    },
  },
  en: {
    lead: 'Lead',
    leads: 'Leads',
    account: 'Account',
    accounts: 'Accounts',
    opport: 'Opportunity',
    opportunities: 'Opportunities',
    users: 'Users',
    joinDate: 'Join Date',
    department: 'Department',
    leadPageLayout: 'Lead Page Layout',
    accountPageLayout: 'Account Page Layout',
    opportunitiesPageLayout: 'Opportunity Page Layout',
    field: 'Field',
    fields: 'Fields',
    dashboard: 'Dashboard',
    report: 'Report',
    reports: 'Reports',
    view: 'View',
    months: {
      Jan: 'January',
      Feb: 'February',
      Mar: 'March',
      Apr: 'April',
      May: 'May',
      Jun: 'June',
      Jul: 'July',
      Agu: 'August',
      Sep: 'September',
      Oct: 'October',
      Nov: 'November',
      Dec: 'December',
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/global/properNouns.js